import Column from '@components/column'
import Title from '@components/title'
import React, { Fragment, useEffect } from 'react'
import {
  StyleContent,
  StyleMaintainanceWrapper,
  Stylesubtitle,
  StyleTitle,
} from './style'
import Svg from '@components/svg'
import { switchOff, switchOn } from '@assets/icons'
import AppSettings from '@commons/settings/app'
import generalSettings from '@apis/generalSettings'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@store/index'
import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import Button from '@components/button'

const MaintainanceMode = () => {
  const dispatch = useDispatch()

  const { data: mode } = useSelector(
    (state: RootState) => state.maintainanceMode,
  )
  const { data: appMode } = useSelector((state: RootState) => state.appMode)
  const { data: platformCharge } = useSelector(
    (state: RootState) => state.platformCharge,
  )

  // Fetch all keys on mount
  useEffect(() => {
    const fetchAll = async () => {
      try {
        await generalSettings.getByKey({
          id: 'maintenance-mode',
          state: 'maintainanceMode',
        })
        await generalSettings.getByKey({ id: 'app-mode', state: 'appMode' })
        await generalSettings.getByKey({
          id: 'platform-charge',
          state: 'platformCharge',
        })
      } catch (error) {
        console.error(error)
      }
    }
    fetchAll()
  }, [dispatch])

  return (
    <Fragment>
      {/* Maintenance Mode */}
      <Column>
        <Title textone="Maintainance" texttwo="Mode" />
        <StyleMaintainanceWrapper>
          <StyleContent>
            <StyleTitle>Enable Maintainance Mode</StyleTitle>
            <Stylesubtitle>
              Activating Maintenance Mode will temporarily pause the app for all
              users...
            </Stylesubtitle>
          </StyleContent>

          <Svg
            src={mode?.value === 'true' ? switchOn : switchOff}
            onClick={async () => {
              if (!mode?.id) {
                await generalSettings.create({
                  data: JSON.stringify({
                    key: 'maintenance-mode',
                    value: 'true',
                  }),
                  state: 'maintainanceMode',
                })
              } else {
                await generalSettings.update({
                  id: mode.id,
                  state: 'maintainanceMode',
                  data: {
                    value: mode.value === 'true' ? 'false' : 'true',
                    key: mode.key,
                  },
                })
              }
            }}
          />
        </StyleMaintainanceWrapper>
      </Column>

      {/* Dev Mode */}
      <br />
      <br />
      <Column>
        <Title textone="Dev" texttwo="Mode" />
        <StyleMaintainanceWrapper>
          <StyleContent>
            <StyleTitle>Enable Dev Mode</StyleTitle>
            <Stylesubtitle>
              Activating Dev Mode enables developer-specific tools and views...
            </Stylesubtitle>
          </StyleContent>

          <Svg
            src={appMode?.value === 'dev' ? switchOn : switchOff}
            onClick={async () => {
              if (!appMode?.id) {
                await generalSettings.create({
                  data: JSON.stringify({ key: 'app-mode', value: 'dev' }),
                  state: 'appMode',
                })
              } else {
                await generalSettings.update({
                  id: appMode.id,
                  state: 'appMode',
                  data: {
                    value: appMode.value === 'dev' ? 'game' : 'dev',
                    key: appMode.key,
                  },
                })
              }
            }}
          />
        </StyleMaintainanceWrapper>
      </Column>
      {/* App Settings */}
      <br />
      <br />

      <Column>
        <Title textone="App" texttwo="Settings" />
        <AppSettings />
      </Column>

      {/* Platform Charge */}
      <br />
      <br />
      <Column>
        <Title textone="Platform" texttwo="Charge" />
        <StyleMaintainanceWrapper>
          <StyleContent>
            <StyleTitle>Platform Charge</StyleTitle>
            <Formik
              enableReinitialize
              initialValues={{
                charge: platformCharge?.value || '',
              }}
              onSubmit={async (values, { setSubmitting }) => {
                try {
                  if (!platformCharge?.id) {
                    await generalSettings.create({
                      data: JSON.stringify({
                        key: 'platform-charge',
                        value: values.charge,
                      }),
                      state: 'platformCharge',
                    })
                  } else {
                    await generalSettings.update({
                      id: platformCharge.id,
                      state: 'platformCharge',
                      data: {
                        value: values.charge,
                        key: platformCharge.key,
                      },
                    })
                  }
                } catch (err) {
                  console.error(err)
                } finally {
                  setSubmitting(false)
                }
              }}
            >
              {() => (
                <Form>
                  <Column>
                    <Fields.Input name="charge" placeholder="Enter Here" />
                    <Button title="Save" type="submit" />
                  </Column>
                </Form>
              )}
            </Formik>
          </StyleContent>
        </StyleMaintainanceWrapper>
      </Column>
    </Fragment>
  )
}

export default MaintainanceMode
